export class Scope {
    id: string;
    name: string;
    displayOrder: number;
    parent: Scope;
    children: Scope[];
    modifiedOn: string;
    modifiedBy: string;
    concurrencyToken: string;
}



// WEBPACK FOOTER //
// D:/a/1/s/src/app/entities/scope.ts